import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesFeaturelistSection from "../../components/IndustriesFeatureListSection";
import {
    FoodBGVideo, FoodProccessingVideo, OverlayImg2,
    BusinessOutcomes1,
    ConnectedMaintenance,
    DigitalEnablers1,
    FoodSafetyCompliance,
    FoodSafetyExcellence,
    ManufacturingPerformance,
    QualityTraceability,
    SupplyChainVisibility1,
    SustainabilityResourceManagement,
} from "../../constant";
import ThreeLongCard from "../../components/IndustriesThreeLongCard";
import ParaVideoSection from "../../components/IndustriesParaVideoSection";
import FoodProcessingLanding from "../../components/Industries/FoodProcessingLanding";

const AnimatedCardCrausalData = [
    {
        title: "Food Safety & Compliance",
        icon:FoodSafetyCompliance,
        description:
            "Ensure adherence to food safety standards and regulatory requirements.",
        data:
            "Monitor critical control points, automate compliance workflows, manage audits, and maintain end-to-end visibility across food safety processes.",
    },
    {
        title: "Quality & Traceability",
        icon:QualityTraceability,
        description:
            "Track every batch from raw materials to finished products.",
        data:
            "Establish complete lot genealogy, automate quality inspections, manage deviations, and accelerate recall readiness.",
    },
    {
        title: "Manufacturing Performance",
        icon:ManufacturingPerformance,
        description:
            "Improve throughput, utilization, and line performance.",
        data:
            "Capture production data in real time to monitor OEE, bottlenecks, yield losses, downtime, and resource utilization.",
    },
    {
        title: "Connected Maintenance",
        icon:ConnectedMaintenance,
        description:
            "Reduce equipment failures and unplanned production disruptions.",
        data:
            "Monitor asset health, schedule preventive maintenance, manage work orders, and track equipment performance.",
    },
    {
        title: "Supply Chain Visibility",
        icon:SupplyChainVisibility1,
        description:
            "Synchronize inventory, procurement, warehousing, and distribution.",
        data:
            "Gain visibility into raw material availability, inventory movement, warehouse operations, and outbound logistics.",
    },
    {
        title: "Sustainability & Resource Management",
        icon:SustainabilityResourceManagement,
        description:
            "Optimize energy, water, waste, and resource consumption.",
        data:
            "Track utility consumption, production waste, emissions, and sustainability performance across facilities.",
    },
];

const longCardData = [
    {
        title: "Food Safety Excellence",
        icon:FoodSafetyExcellence,
        listItems: [
            "HACCP Compliance",
            "Quality Assurance",
            "Contamination Prevention",
            "Audit Readiness",
            "Regulatory Conformance",
        ],
    },
    {
        title: "Digital Enablers",
        icon:DigitalEnablers1,
        listItems: [
            "Industrial IoT",
            "Manufacturing Intelligence",
            "Advanced Analytics",
            "AI & Machine Learning",
            "Cloud Platforms",
        ],
    },
    {
        title: "Business Outcomes",
        icon:BusinessOutcomes1,
        listItems: [
            "Higher Yield",
            "Reduced Product Loss",
            "Faster Root Cause Analysis",
            "Improved Asset Availability",
            "Enhanced Consumer Trust",
        ],
    },
];


const featurelist = {
    listTitle: "Building the Intelligent Food Enterprise",
    listSubTitle: [
        "Food processing organizations are redefining how products are manufactured, monitored, and delivered. Connected operations, data-driven insights, and intelligent workflows help improve production performance, strengthen quality assurance, and enhance supply chain responsiveness.",
        "IENERGY enables food manufacturers to unlock greater value from their operations through real-time monitoring, process optimization, predictive maintenance, and end-to-end operational visibility. This creates a foundation for sustainable growth, operational excellence, and continuous improvement."],
    listItems: []
}


const leftSecionData = {
    title: "Creating a Connected Food Value Chain",
    para: ["Digital technologies are reshaping how food products are manufactured, monitored, and delivered. Organizations that integrate operational data across plants, warehouses, suppliers, and distribution networks gain the agility required to respond to market demands while maintaining product integrity and operational consistency."],
    listItems: [
        "Product Traceability & Recall Readiness",
        "Manufacturing Performance Management",
        "Food Safety & Quality Excellence",
        "Asset Reliability & Plant Availability",
        "Supply Chain Resilience",
    ],
    mediaUrl: FoodProccessingVideo,
    imgeUrl: OverlayImg2,
}



export default function FoodProcessingPage() {
    return (
        <>
            <FoodProcessingLanding />
            <AnimatedCardCrausal
                title={"Advancing Food Manufacturing Through Connected Operations"}
                subTitle={"Connect production, quality, maintenance, supply chain, and compliance functions through a unified digital ecosystem. IENERGY helps food manufacturers improve throughput, strengthen traceability, reduce losses, and maintain consistent product quality across operations."}
                data={AnimatedCardCrausalData}
            />

            <ParaVideoSection
                title={"Building the Next Generation of Food Operations"}
                subTitle={"Food manufacturers are navigating a rapidly evolving landscape shaped by changing consumer expectations, stringent regulatory requirements, supply chain volatility, and increasing pressure to deliver consistent quality at scale."}
                data={leftSecionData}
            />
            <ThreeLongCard
                title={"Unlock Value Across the Food Manufacturing Value Chain"}
                subTitle={"Leverage connected operations, real-time visibility, and intelligent insights to enhance quality, traceability, and operational performance."}
                data={longCardData}
            />
            <IndustriesFeaturelistSection data={featurelist} backgroundItem={FoodBGVideo} />
            <AchieveOutcome
                title={`Reimagining Performance Across the Food Value Chain`}
                subTitle={`Food manufacturers are navigating rising input costs, evolving consumer expectations, stricter quality requirements, and increasing supply chain complexity. Digital capabilities provide the foundation for greater operational visibility, stronger product integrity, and more resilient manufacturing networks.`}
            />

            <WeAreIED />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
